<template>
<div>
  <div class="tag-nav-wrapper">
    <div class="tags-nav">
        <div class="close-con">
          <Dropdown transfer @on-click="handleTagsOption" style="margin-top:7px;">
            <Button size="small" type="text">
              <Icon :size="18" type="ios-close-outline"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem name="close-all">关闭所有</DropdownItem>
              <DropdownItem name="close-others">关闭其他</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="btn-con left-btn">
          <Button icon="chevron-left" type="text" @click="handleScroll(240)"></Button>
        </div>
        <div class="btn-con right-btn">
          <Button icon="chevron-right" type="text" @click="handleScroll(-240)"></Button>
        </div>
        <div class="scroll-outer" ref="scrollOuter" @DOMMouseScroll="handlescroll" @mousewheel="handlescroll">
          <div ref="scrollBody" class="scroll-body" :style="{left: tagBodyLeft+ 'px'}">
            <transition-group name="taglist-moving-animation">
              <div :key="item.name" v-for="(item,index) in list" class="tag">
                <Tag
                  type="dot"
                  :ref="'tagsPageOpened'+index"
                  :key="`tag-nav-${item.name}`"
                  :name="item.name"
                  @on-close="handleClose"
                  @click.native="handleClick(item,index)"
                  :closable="item.name !== 'home'"
                  :color="item.name === value ? setShowOffset(item,index) : 'default'"
                >{{ showTitleInside(item) }}</Tag>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div v-for="(item,index) in list" :key="index" :name="item.name">
        <router-view v-show="value==item.name" :name="item.name" :key="item._activeDate"/>
      </div>
      <router-view v-if="$route.path=='/demoList'" name="demoList"/>
      <router-view v-else-if="list.length==0" name="home"/>
      <router-view v-if="$route.path=='/navigation'" name="navigation"/>
    </div>
  </div>
</template>


<style lang="scss" scoped> 
.no-select{
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.size{
  width: 100%;
  height: 100%;
}
.tag-nav-wrapper {
    padding: 0;
    height: 35px;
    background: #f5f5f5;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 20;
    width: 100%;
}
.tags-nav{
  position: relative;
  // border-top: 1px solid #F0F0F0;
  border-bottom: 1px solid #d2d2d2;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
  height: 100%;
  .tag{
    background: #E1E1E7;
    margin: 0px 2px;
    display: inline-block;
    border-radius: 3px 3px 0 0;
  }
  .close-con{
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 32px;
    background: #ffffff;
    text-align: center;
    z-index: 10;
  }
  .btn-con{
    position: absolute;
    top: 0px;
    height: 100%;
    background: #ffffff;
    padding-top: 3px;
    z-index: 10;
    button{
      padding: 6px 10px;
      text-align: center;
    }
    &.left-btn{
      left: 0px;
      background: #E8E8E8;
      .ihlp-icon-r{
        font-weight:bolder;
        color:#CFCFCF;
        font-size:14px;
      }
    }
    &.right-btn{
      right: 32px;
      border-right: 1px solid #F0F0F0;
      background: #E8E8E8;
      .ihlp-icon-r{
        font-weight:bolder;
        color:#CFCFCF;
      }
    }
  }
  .scroll-outer{
    position: absolute;
    left: 50px;
    right: 85px;
    top: 0;
    bottom: 0;
    overflow:hidden;
    height:35px;
    // box-shadow: 0px 0 3px 2px rgba(100,100,100,.1) inset;
    .scroll-body{
      //height: calc(100% - 1px);
      display: inline-block;
      position: absolute;
      overflow: visible;
      white-space: nowrap;
      transition: left .3s ease;
      .ivu-tag-dot-inner{
        display:none;
      }
      .ivu-tag{
        margin:0px;
      }
      .ivu-tag-dot{
        height: 34px;
        border-radius: 2px 2px 0 0;
        background: #E1E1E7 !important;
        border-radius: 3px 3px 0 0;
        border-bottom:1px solid #d2d2d2 !important;
      }
      .ivu-tag-blue{
        height: 36px;
        border:1px solid #d2d2d2 !important;
        background: #ffffff !important;
        .ivu-tag-text{
           color:#00b5e2 !important;
        }
      }
    }
  }
}
.btn-con.left-btn:hover .ihlp-icon-r{
  color:#BCBCD1 !important;
}
.btn-con.right-btn:hover .ihlp-icon-r{
  color:#BCBCD1 !important;
}
.som-body .ivu-tag{
  overflow:visible;
}
</style>

<script>
export default {
  name: 'tagsNav',
  props: {
    value: String,
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      tagBodyLeft: 0,
      setShowOffsetIndex:0
    }
  },
  created(){
  },
  methods: {
    handlescroll (e) {
      var type = e.type
      let delta = 0
      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = (e.wheelDelta) ? e.wheelDelta : -(e.detail || 0) * 40
      }
      this.handleScroll(delta)
    },
    handleScroll (offset) {
      if (offset > 0) {
        this.tagBodyLeft = Math.min(0, this.tagBodyLeft + offset)
      } else {
        if (this.$refs.scrollOuter.offsetWidth < this.$refs.scrollBody.offsetWidth) {
          if (this.tagBodyLeft < -(this.$refs.scrollBody.offsetWidth - this.$refs.scrollOuter.offsetWidth)) {
            this.tagBodyLeft = this.tagBodyLeft
          } else {
            this.tagBodyLeft = Math.max(this.tagBodyLeft + offset, this.$refs.scrollOuter.offsetWidth - this.$refs.scrollBody.offsetWidth)
          }
        } else {
          this.tagBodyLeft = 0
        }
      }
    },
    handleTagsOption (type) {
      if (type === 'close-all') {
        // 关闭所有，除了home
        let res = this.list.filter(item => item.name === 'home')
        this.$emit('on-close', res, 'all')
      } else {
        // 关闭除当前页和home页的其他页
        let res = this.list.filter(item => item.name === this.value)||{}
        this.$emit('on-close', res, 'others')
      }
    },
    handleClose (e, name) {
      let res= this.list.filter(item => item.name !== name)||[]
      this.$emit('on-close', res, undefined,name)
    },
    handleClick (item,index) {
      this.$emit('input', item,index)
    },
    showTitleInside (item) {
      return this.$t(item.title)
    },
    //动态调整tab显示的位置
    setShowOffset(item,index){
      if(this.setShowOffsetIndex!=index){
        this.setShowOffsetIndex=index
        let self=this,list=this.list,
        //之前偏移的位置
        tagW=this.tagBodyLeft,
        //选中的tab的位置
        itemAllW=0;
        this.$nextTick(function(){
          //显示总宽度
          const scrollOuterWidth=this.$refs.scrollOuter.offsetWidth
          //实际宽度
          const scrollBodyWidth=self.$refs.scrollBody.offsetWidth
          for(let i=0;i<=index;i++){
            let itemRef="tagsPageOpened"+i
            itemAllW+=self.$refs[itemRef][0].$el.offsetWidth+4
          }
          //如果显示宽度小于实际宽度才处理，否则偏移宽度为0
          if(scrollOuterWidth<scrollBodyWidth){
            let num=itemAllW-(scrollOuterWidth-tagW)
            //如果宽度超过显示宽度和偏移之和，超过多少偏移再加多少
            if(num>0){
              self.tagBodyLeft=tagW-num
            }else if(scrollOuterWidth+num<0){
              //如果实际位置在一个显示宽度内，直接设置偏移为0
              if(scrollOuterWidth>itemAllW){
                self.tagBodyLeft=0
              }else{
                self.tagBodyLeft=scrollOuterWidth-itemAllW
              }
            } 
          }else{
            self.tagBodyLeft=0
          }
        })
      }
      return 'blue'
    }
  },
  // watch:{
  //   list(newValue,oldValue){
  //     this.tabs=newValue
  //   }
  // }
}
</script>




// WEBPACK FOOTER //
// src/layout/tagsNav.vue